module.exports = __webpack_public_path__ + "static/img/card_icon_brand@2x.1baf7fb0.png";